import { DatePicker, Popover, Spin } from "antd";
import TextArea from "antd/lib/input/TextArea";
import { Button } from "primereact/button";
import { Column } from "primereact/column";
import { confirmDialog } from "primereact/confirmdialog";
import { DataTable } from "primereact/datatable";
import { Toolbar } from "primereact/toolbar";
import React, { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import { useHistory, useLocation } from "react-router-dom";
import {
  acceptedProject,
  changesRequestedProject,
  copyProject,
  deliveredProjects,
  finalCheckProject,
  getAllProjects,
  getAllProjectsCount,
  getFeedbacks,
  getMissingE57Files,
  makeChangesProject,
  searchProject,
  searchProjectCount,
  submitProject
} from "../../../apis/ProjectApis";
import inProgress from "./../../../resources/in-progress.svg";
import ready from "./../../../resources/ready.svg";

import { InputText } from "primereact/inputtext";
import { Paginator } from "primereact/paginator";
import { Toast } from "primereact/toast";
import { Tooltip } from "primereact/tooltip";
import {
  ACCEPTED,
  ADJUSTMENTS_REQUESTED,
  compareEta,
  conditionForProjectToFinalCheckForQualityCheck,
  conditionToAssignProjectCoodinator,
  conditionToCopyProject,
  conditionToProjectAssignToContractor,
  conditionToProjectAssignToQualityChecker,
  conditionToProjectFinalCheckForCustomerReview,
  conditionToProjectForAccept,
  conditionToProjectForAdjustmentRequired,
  conditionToProjectForDelivered,
  conditionToProjectForMakeChanges,
  conditionToProjectForRequestChanges,
  conditionToProjectReAssignToContractor,
  conditionToReturnToFinalCheck,
  DELIVERED,
  etaDateDisplay,
  FINAL_CHECK,
  getProjectStatus,
  IN_PROGRESS,
  MAKE_CHANGES,
  PROJECT_IDS,
  QUALITY_CHECK,
  USER_TYPE_OWNER
} from "../../../utils/constants";
import AssignToContractorDialog from "../dialog/assigntocontractordialog";
import AssignToManagerDialog from "../dialog/assigntomanagerdialog";
import AssigntoqualityCheckerDialog from "../dialog/assigntoqualitycheckerdialog";
import CustomerRequestChangeDialog from "../dialog/CustomerRequestChangesDialog";
import FeedbackDialog from "../dialog/FeedbackDialog";
import "./style.scss";
import moment from "moment";
import { isAutoCad } from "../../../utils/projectUtils";

const ProjectDetail = (props) => {
  const history = useHistory();
  const location = useLocation();

  const getPagingStateFromUrl = (search) => {
    const params = new URLSearchParams(search);
    const pageParam = Number(params.get("page"));
    const sizeParam = Number(params.get("size"));
    const parsedPage = Number.isNaN(pageParam) ? 0 : Math.max(pageParam, 0);
    const parsedSize = Number.isNaN(sizeParam) ? 30 : Math.max(sizeParam, 30)  ;

    return {
      page: parsedPage,
      size: parsedSize,
      first: parsedPage * parsedSize,
    };
  };

  const updatePagingUrl = (page, size) => {
    const params = new URLSearchParams(location.search);
    params.set("page", String(page));
    params.set("size", String(size));

    const nextSearch = params.toString();
    const nextUrl = nextSearch ? `?${nextSearch}` : "";

    if (history.location.search !== nextUrl) {
      history.replace({
        pathname: history.location.pathname,
        search: nextUrl,
      });
    }
  };

  const initialPagingState = getPagingStateFromUrl(location.search);

  const [projects, setProjects] = useState([]);
  const [basicFirst, setBasicFirst] = useState(initialPagingState.first);
  const [totalRows, setTotalRows] = useState(initialPagingState.size);
  const [pageNumber, setPageNumber] = useState(initialPagingState.page);
  const [apiLoading, setApiLoading] = useState(false);
  const [totalRecords, setTotalRecords] = useState();
  const [visibleContractorDialog, setVisibleContractorDialog] = useState(false);
  const [visibleQualityCheckerDialog, setVisibleQualityCheckerDialog] =
    useState(false);
  const [
    visibleCustomerRequestChangeDialog,
    setVisibleCustomerRequestChangeDialog,
  ] = useState(false);
  const [visibleFeedbackDialog, setVisibleFeedbackDialog] = useState(false);
  const [visibleManagerDialog, setVisibleManagerDialog] = useState(false);
  const [project, setProject] = useState(null);
  const [globalFilterValue, setGlobalFilterValue] = useState("");
  const [priceSearchValue, setPriceSearchValue] = useState("");
  const { currentUser = {} } = useSelector(({ app }) => app);
  const [permissions, setPermissions] = useState([]);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [projectMissingE57Files, setProjectMissingE57Files] = useState([]);

  const dt = useRef(null);
  const toast = useRef(null);
  const messageInputRef = useRef(null);
  // Function to add tooltip text to each row
  const rowClassName = (rowData) => {
    return {
      [`tooltip-row-${rowData.projectId}`]: true, // Unique class per row
      'p-datatable-row-hover': true // Ensures hover effect
    };
  };
  const loadProjects = (current, pageSize) => {
    setApiLoading(true);
    getAllProjects(current, pageSize)
      .then((response) => {
        if (response.status === 200) {
          setProjects(response.data);
          setApiLoading(false);
          window.localStorage.setItem(PROJECT_IDS, response.data.map(t => t.id));

        } else {
          toast.current.show({
            severity: "error",
            summary: "Status",
            detail: response.response.data,
            life: 3000,
          });
          setApiLoading(false);
        }
      })
      .catch((e) => {
        toast.current.show({
          severity: "error",
          summary: "Status",
          detail: e,
          life: 3000,
        });
        setApiLoading(false);
      });
  };

  useEffect(() => {
    const currentPagingState = getPagingStateFromUrl(location.search);
    const hasPageParam = new URLSearchParams(location.search).has("page");
    const hasSizeParam = new URLSearchParams(location.search).has("size");

    if (!hasPageParam || !hasSizeParam) {
      updatePagingUrl(pageNumber, totalRows);
      return;
    }

    if (
      currentPagingState.page !== pageNumber ||
      currentPagingState.size !== totalRows
    ) {
      setBasicFirst(currentPagingState.first);
      setPageNumber(currentPagingState.page);
      setTotalRows(currentPagingState.size);
    }
  }, [location.search]);

  const onBasicPageChange = (event) => {
    setApiLoading(true);
    setBasicFirst(event.first);
    setPageNumber(event.page);
    setTotalRows(event.rows);
    updatePagingUrl(event.page, event.rows);
    setApiLoading(false);
  };

  const fetchProjectCount = () => {
    if (pageNumber >= 0 && totalRows >= 10) {
      setApiLoading(true);
      getAllProjectsCount()
        .then((res) => {
          if (res.status === 200) {
            setTotalRecords(res.data);
            loadProjects(pageNumber, totalRows);
            setApiLoading(false);
          } else {
            toast.current.show({
              severity: "error",
              summary: "Status",
              detail: res.response.data,
              life: 3000,
            });
            setApiLoading(false);
          }
        })
        .catch((e) => {
          toast.current.show({
            severity: "error",
            summary: "Status",
            detail: e,
            life: 3000,
          });
          setApiLoading(false);
        });
    }
  };

  useEffect(() => {
    if ((globalFilterValue !== "" || priceSearchValue !== "") || (startDate != null && endDate != null)) {
      onGlobalFilterChange(startDate, endDate);
    } else {
      fetchProjectCount();
    }
    /* eslint-disable react-hooks/exhaustive-deps */
  }, [pageNumber, totalRows]);

  const fetchPermissions = () => {
    const uniquePermissions = {};
    if (currentUser && currentUser.roles) {
      currentUser.roles.forEach((role) => {
        role.permissions.forEach(
          (permission) => (uniquePermissions[permission.id] = permission)
        );
      });
    }
    setPermissions(Object.values(uniquePermissions));
  };

  useEffect(() => {
    fetchPermissions();
  }, [currentUser]);

  useEffect(() => {
    fetchMissingE57File();
  }, []);

  const handleFinalCheckProject = (record, isAssignToMe, message = "") => {
    if (record && record.id) {
      setApiLoading(true);
      finalCheckProject(record.id, isAssignToMe, message)
        .then((res) => {
          if (res.status === 200) {
            toast.current.show({
              severity: "success",
              summary: "Status",
              detail: "Project Status Change To Ready Successfully",
              life: 3000,
            });
            fetchProjectCount();
            setApiLoading(false);
          } else {
            toast.current.show({
              severity: "error",
              summary: "Status",
              detail: res.response.data,
              life: 3000,
            });
            setApiLoading(false);
          }
        })
        .catch((e) => {
          toast.current.show({
            severity: "error",
            summary: "Status",
            detail: e,
            life: 3000,
          });
          setApiLoading(false);
        });
    } else {
      toast.current.show({
        severity: "warn",
        summary: "Status",
        detail: "No Selected Project",
        life: 3000,
      });
    }
  };

    const fetchMissingE57File = () => {
      setApiLoading(true);
      getMissingE57Files()
        .then((response) => {
          if (response.status === 200) {
            setProjectMissingE57Files(response.data);
          } else {
            toast.current.show({
              severity: "error",
              summary: "Status",
              detail: response.response.data,
              life: 3000,
            });
            setApiLoading(false);
          }
        })
        .catch((e) => {
          toast.current.show({
            severity: "error",
            summary: "Status",
            detail: e,
            life: 3000,
          });
          setApiLoading(false);
        });
    };

  const handleMakeChangesProject = (record) => {
    if (record && record.id) {
      setApiLoading(true);
      makeChangesProject(record.id)
        .then((res) => {
          if (res.status === 200) {
            toast.current.show({
              severity: "success",
              summary: "Status",
              detail: "Project Status Change To Make Changes Successfully",
              life: 3000,
            });
            fetchProjectCount();
            setApiLoading(false);
          } else {
            toast.current.show({
              severity: "error",
              summary: "Status",
              detail: res.response.data,
              life: 3000,
            });
            setApiLoading(false);
          }
        })
        .catch((e) => {
          toast.current.show({
            severity: "error",
            summary: "Status",
            detail: e,
            life: 3000,
          });
          setApiLoading(false);
        });
    } else {
      toast.current.show({
        severity: "warn",
        summary: "Status",
        detail: "No Selected Project",
        life: 3000,
      });
    }
  };

  const customerAcceptProject = (record, isAssignToMe, message = "") => {
    if (record && record.id) {
      setApiLoading(true);
      acceptedProject(record.id, isAssignToMe, message)
        .then((res) => {
          if (res.status === 200) {
            fetchProjectCount();
            toast.current.show({
              severity: "success",
              summary: "Status",
              detail: "Project Status Change To Accepted Successfully",
              life: 3000,
            });
            setApiLoading(false);
          } else {
            toast.current.show({
              severity: "error",
              summary: "Status",
              detail: res.response.data,
              life: 3000,
            });
            setApiLoading(false);
          }
        })
        .catch((e) => {
          toast.current.show({
            severity: "error",
            summary: "Status",
            detail: e,
            life: 3000,
          });
          setApiLoading(false);
        });
    } else {
      toast.current.show({
        severity: "warn",
        summary: "Status",
        detail: "No Selected Project",
        life: 3000,
      });
    }
  };

  const customerChangesRequestedProject = (record) => {
    if (record && record.id) {
      setApiLoading(true);
      changesRequestedProject(record.id)
        .then((res) => {
          if (res.status === 200) {
            fetchProjectCount();
            toast.current.show({
              severity: "success",
              summary: "Status",
              detail:
                "Project Status Change To Adjustments Required Successfully",
              life: 3000,
            });
            setApiLoading(false);
          } else {
            toast.current.show({
              severity: "error",
              summary: "Status",
              detail: res.response.data,
              life: 3000,
            });
            setApiLoading(false);
          }
        })
        .catch((e) => {
          toast.current.show({
            severity: "error",
            summary: "Status",
            detail: e,
            life: 3000,
          });
          setApiLoading(false);
        });
    } else {
      toast.current.show({
        severity: "warn",
        summary: "Status",
        detail: "No Selected Project",
        life: 3000,
      });
    }
  };

  const handleSubmitProject = (project) => {
    if (project && project.id) {
      setApiLoading(true);
      submitProject(project.id)
        .then((res) => {
          if (res.status === 200) {
            fetchProjectCount();
            toast.current.show({
              severity: "success",
              summary: "Status",
              detail: "Project Submitted For Quality Check Successfully",
              life: 3000,
            });
            setApiLoading(false);
          } else {
            toast.current.show({
              severity: "error",
              summary: "Status",
              detail: res.response.data,
              life: 3000,
            });
            setApiLoading(false);
          }
        })
        .catch((e) => {
          toast.current.show({
            severity: "error",
            summary: "Status",
            detail: e,
            life: 3000,
          });
          setApiLoading(false);
        });
    } else {
      toast.current.show({
        severity: "warn",
        summary: "Status",
        detail: "No Selected Project",
        life: 3000,
      });
    }
  };

  const managerDeliverProject = (project) => {
    if (project && project.id) {
      setApiLoading(true);
      deliveredProjects(project.id)
        .then((res) => {
          if (res.status === 200) {
            fetchProjectCount();
            toast.current.show({
              severity: "success",
              summary: "Status",
              detail: "Project Submitted For Quality Check Successfully",
              life: 3000,
            });
            setApiLoading(false);
          } else {
            toast.current.show({
              severity: "error",
              summary: "Status",
              detail: res.response.data,
              life: 3000,
            });
            setApiLoading(false);
          }
        })
        .catch((e) => {
          toast.current.show({
            severity: "error",
            summary: "Status",
            detail: e,
            life: 3000,
          });
          setApiLoading(false);
        });
    } else {
      toast.current.show({
        severity: "warn",
        summary: "Status",
        detail: "No Selected Project",
        life: 3000,
      });
    }
  };

  const handleReturnToFinalCheck = (record) => {
    if (record && record.id) {
      setApiLoading(true);
      finalCheckProject(record.id, false)
        .then((res) => {
          if (res.status === 200) {
            toast.current.show({
              severity: "success",
              summary: "Status",
              detail: "Project Status Change To Final Check Successfully",
              life: 3000,
            });
            fetchProjectCount();
            setApiLoading(false);
          } else {
            toast.current.show({
              severity: "error",
              summary: "Status",
              detail: res.response.data,
              life: 3000,
            });
            setApiLoading(false);
          }
        })
        .catch((e) => {
          toast.current.show({
            severity: "error",
            summary: "Status",
            detail: e,
            life: 3000,
          });
          setApiLoading(false);
        });
    } else {
      toast.current.show({
        severity: "warn",
        summary: "Status",
        detail: "No Selected Project",
        life: 3000,
      });
    }
  };

  const handleCopyProject = (project) => {
    if (project && project.id) {
      setApiLoading(true);
      copyProject(project.id)
        .then((res) => {
          if (res.status === 200) {
            fetchProjectCount();
            toast.current.show({
              severity: "success",
              summary: "Status",
              detail: "Project Copy Successfully!",
              life: 3000,
            });
            setApiLoading(false);
          } else {
            toast.current.show({
              severity: "error",
              summary: "Status",
              detail: res.response.data,
              life: 3000,
            });
            setApiLoading(false);
          }
        })
        .catch((e) => {
          toast.current.show({
            severity: "error",
            summary: "Status",
            detail: e,
            life: 3000,
          });
          setApiLoading(false);
        });
    } else {
      toast.current.show({
        severity: "warn",
        summary: "Status",
        detail: "No Selected Project",
        life: 3000,
      });
    }
  };

  const handleOpenFeedbackDialog = (record) => {
    if (record && record.id) {
      setProject(record);
      setApiLoading(true);
      getFeedbacks(record.id)
        .then((res) => {
          if (res.status === 200) {
            if (res.data && res.data.length > 0) {
              setVisibleFeedbackDialog(true);
              setApiLoading(false);
            } else {
              // No feedbacks available, move status
              setApiLoading(false);
              handleMoveStatusAfterFeedback(record);
            }
          } else {
            toast.current.show({
              severity: "error",
              summary: "Status",
              detail: res.response.data,
              life: 3000,
            });
            setApiLoading(false);
          }
        })
        .catch((e) => {
          toast.current.show({
            severity: "error",
            summary: "Status",
            detail: e,
            life: 3000,
          });
          setApiLoading(false);
        });
    } else {
      toast.current.show({
        severity: "warn",
        summary: "Status",
        detail: "No Selected Project",
        life: 3000,
      });
    }
  };

  const changeVisibleCustomerRequestChangeDialogState = (bool) => {
    setApiLoading(false);
    fetchProjectCount();
    setVisibleCustomerRequestChangeDialog(bool);
  };

  const changeVisibleFeedbackDialogState = (bool, isMoveStatus) => {
    setApiLoading(false);
    setVisibleFeedbackDialog(bool);
    if (!isMoveStatus) {
      return;
    }
    handleMoveStatusAfterFeedback(project);
  };

  const handleMoveStatusAfterFeedback = (project) => {
    const renderAcceptMessageDialog = (rows = 4, placeholder = "Message for the customer") => (
      <div>
        <label>Are you sure you want to change status to Accept?</label>
        <div style={{ marginTop: 12, width: "100%", minWidth: 0, maxWidth: "100%" }}>
          <textArea
            ref={messageInputRef}
            rows={rows}
            style={{ width: "100%", maxWidth: "100%", minWidth: 0, display: "block", boxSizing: "border-box" }}
            defaultValue=""
            placeholder={placeholder}
          />
        </div>
      </div>
    );

    const showAcceptMessageDialog = (isAssignToMe, rows = 4) => {
      confirmDialog({
        message: renderAcceptMessageDialog(rows),
        header: "Confirmation",
        icon: "pi pi-envelope",
        acceptLabel: "Send",
        rejectLabel: "Cancel",
        accept: () => customerAcceptProject(project, isAssignToMe, messageInputRef.current?.value || ""),
      });
    };

    switch (project?.projectStatus) {
      case IN_PROGRESS:
      case MAKE_CHANGES:
        confirmDialog({
          message:
            "Are you sure you want to submit the project for Quality Check?",
          header: "Confirmation",
          icon: "pi pi-exclamation-triangle",
          accept: () => handleSubmitProject(project),
        });
        break;
      case QUALITY_CHECK:
      case ADJUSTMENTS_REQUESTED:
        if (
          project?.qualityChecker == null
          && project?.employee?.id != currentUser?.id
          && project?.parentId == null
        ) {
          confirmDialog({
            message:
              "Do you want to assign yourself to Quality Checker?",
            header: "Confirmation",
            icon: "pi pi-exclamation-triangle",
            accept: () => handleFinalCheckProject(project, true),
            reject: () => handleFinalCheckProject(project, false),
          });
        } else {
          confirmDialog({
            message: "Are you sure you want to proceed?",
            header: "Confirmation",
            icon: "pi pi-exclamation-triangle",
            accept: () => handleFinalCheckProject(project, false, ""),
          });
        }
        break;
      //Case return to final check
      case ACCEPTED:
      case DELIVERED:
        confirmDialog({
          message: "Are you sure you want to proceed?",
          header: "Confirmation",
          icon: "pi pi-exclamation-triangle",
          accept: () => handleReturnToFinalCheck(project),
        });
      break;
      case FINAL_CHECK:
        if (project.manager == null) {
          confirmDialog({
            message: (
              <div>
                Do you want to assign yourself to Project Final Checker?
              </div>
            ),
            header: "Confirmation",
            icon: "pi pi-exclamation-triangle",
            accept: () => showAcceptMessageDialog(true, 3),
            reject: () => showAcceptMessageDialog(false, 3),
          });
        } else {
          showAcceptMessageDialog(false, 4);
        }
    } 
  };

  const content = (record) => {
    return (
      <div className="flex flex-column align-items-start gap-2">
        <div>
          <Button
            style={{ width: "120px" }}
            shape="round"
            className="p-button-outlined p-button-text text-left"
            label="View Details"
            onClick={(e) => {
              e.stopPropagation();
              window.localStorage.setItem(PROJECT_IDS, projects.map(t => t.id));
              history.push({
                pathname: `/${record.id}/projectEdit`,
                state: {
                  id: record.id,
                  agencyFormat: record.agency.agencyFormat,
                },
              });
            }}
          />
        </div>

        {conditionForProjectToFinalCheckForQualityCheck(record, permissions) ? (
          <div>
            <Button
              style={{ width: "120px" }}
              shape="round"
              className="p-button-outlined p-button-text text-left"
              label="Ready for Quality Check"
              onClick={(e) => {
                e.stopPropagation();
                handleOpenFeedbackDialog(record);
              }}
            />
          </div>
        ) : (
          ""
        )}

        {conditionToAssignProjectCoodinator(record, permissions) ? (
          <div>
            <Button
              style={{ width: "140px" }}
              shape="round"
              className="p-button-outlined p-button-text text-left"
              label={
                record?.manager?.id
                  ? "Re-Assign Project Final Checker"
                  : "Assign Project Final Checker"
              }
              onClick={(e) => {
                e.stopPropagation();
                setProject(record);
                setApiLoading(true);
                setVisibleManagerDialog(true);
              }}
            />
          </div>
        ) : (
          ""
        )}

        {conditionToProjectAssignToContractor(record, permissions) ? (
          <div>
            <Button
              style={{ width: "140px" }}
              shape="round"
              className="p-button-outlined p-button-text text-left"
              label="Assign to Contractor"
              onClick={(e) => {
                e.stopPropagation();
                setProject(record);
                setApiLoading(true);
                setVisibleContractorDialog(true);
              }}
            />
          </div>
        ) : (
          ""
        )}

        {conditionToProjectReAssignToContractor(record, permissions) ? (
          <div>
            <Button
              style={{ width: "140px" }}
              shape="round"
              className="p-button-outlined p-button-text text-left"
              label="Re-Assign Contractor"
              onClick={(e) => {
                e.stopPropagation();
                setProject(record);
                setApiLoading(true);
                setVisibleContractorDialog(true);
              }}
            />
          </div>
        ) : (
          ""
        )}

        {conditionToProjectAssignToQualityChecker(record, permissions) ? (
          <div>
            <Button
              style={{ width: "140px" }}
              shape="round"
              className="p-button-outlined p-button-text text-left"
              label={
                record?.qualityChecker?.id
                  ? "Re-Assign Quality Checker"
                  : "Assign Quality Checker"
              }
              onClick={(e) => {
                e.stopPropagation();
                setProject(record);
                setApiLoading(true);
                setVisibleQualityCheckerDialog(true);
              }}
            />
          </div>
        ) : (
          ""
        )}

        {conditionToProjectFinalCheckForCustomerReview(record, permissions) ? (
          <div>
            <Button
              style={{ width: "140px" }}
              shape="round"
              className="p-button-outlined p-button-text text-left"
              label="Ready for Final Check"
              onClick={(e) => {
                e.stopPropagation();
                handleOpenFeedbackDialog(record);
              }}
            />
          </div>
        ) : (
          ""
        )}

        {conditionToProjectForAdjustmentRequired(record, permissions) ? (
          <div>
            <Button
              style={{ width: "140px" }}
              shape="round"
              className="p-button-outlined p-button-text text-left"
              label="Customer request change"
              onClick={(e) => {
                e.stopPropagation();
                setApiLoading(true);
                setProject(record);
                console.log("project" + record);
                setVisibleCustomerRequestChangeDialog(true);
              }}
            />
          </div>
        ) : (
          ""
        )}

        {conditionToProjectForMakeChanges(record, permissions) ? (
          <div>
            <Button
              style={{ width: "140px" }}
              shape="round"
              className="p-button-outlined p-button-text text-left"
              label="Make Changes"
              onClick={(e) => {
                e.stopPropagation();
                confirmDialog({
                  message: "Are you sure you want to proceed?",
                  header: "Confirmation",
                  icon: "pi pi-exclamation-triangle",
                  accept: () => handleMakeChangesProject(record),
                });
              }}
            />
          </div>
        ) : (
          ""
        )}

        {conditionToProjectForAccept(record, permissions) ? (
          <div>
            <Button
              style={{ width: "120px" }}
              shape="round"
              className="p-button-outlined p-button-text text-left"
              label="Accept"
              onClick={(e) => {
                e.stopPropagation();
                handleOpenFeedbackDialog(record);
              }}
            />
          </div>
        ) : (
          ""
        )}

        {conditionToProjectForRequestChanges(record, permissions) ? (
          <div>
            <Button
              style={{ width: "120px" }}
              shape="round"
              className="p-button-outlined p-button-text text-left"
              label="Request Changes"
              onClick={(e) => {
                e.stopPropagation();
                confirmDialog({
                  message: "Are you sure you want to proceed?",
                  header: "Confirmation",
                  icon: "pi pi-exclamation-triangle",
                  accept: () => customerChangesRequestedProject(record),
                });
              }}
            />
          </div>
        ) : (
          ""
        )}

        {conditionToReturnToFinalCheck(
          record,
          permissions
        ) ? (
          <div>
            <Button
              style={{ width: "140px" }}
              shape="round"
              className="p-button-outlined p-button-text text-left"
              label="Return to final check"
              onClick={(e) => {
                e.stopPropagation();
                handleOpenFeedbackDialog(record);
              }}
            />
          </div>
        ) : (
          ""
        )} 

        {conditionToProjectForDelivered(record, permissions) ? (
          <div>
            <Button
              style={{ width: "120px" }}
              shape="round"
              className="p-button-outlined p-button-text text-left"
              label="Delivered"
              onClick={(e) => {
                e.stopPropagation();
                confirmDialog({
                  message: "Are you sure you want to proceed?",
                  header: "Confirmation",
                  icon: "pi pi-exclamation-triangle",
                  accept: () => managerDeliverProject(record),
                });
              }}
            />
          </div>
        ) : (
          ""
        )}
        {conditionToCopyProject(record, permissions) ? (
          <div>
            <Button
              style={{ width: "120px" }}
              shape="round"
              className="p-button-outlined p-button-text text-left"
              label="Copy Project"
              onClick={(e) => {
                e.stopPropagation();
                confirmDialog({
                  message: "Are you sure you want to copy this project?",
                  header: "Confirmation",
                  icon: "pi pi-exclamation-triangle",
                  accept: () => handleCopyProject(record),
                });
              }}
            />
          </div>
        ) : (
          ""
        )}
      </div>
      
    );
  };

  const changeVisibleContractorDialogState = (bool) => {
    setApiLoading(false);
    fetchProjectCount();
    setProject(null);
    setVisibleContractorDialog(bool);
  };

  const changeVisibleQualityCheckerDialogState = (bool) => {
    setApiLoading(false);
    fetchProjectCount();
    setProject(null);
    setVisibleQualityCheckerDialog(bool);
  };

  const changeVisibleManagerDialogState = (bool) => {
    setApiLoading(false);
    fetchProjectCount();
    setProject(null);
    setVisibleManagerDialog(bool);
  };

  const onGlobalFilterChange = (startDate, endDate) => {
    let searchData = {
      startDate: startDate && startDate !== "" && `${moment(startDate).format("DD-MM-yyyy")}`,
      endDate: endDate && endDate !== "" && `${moment(endDate).add(1, 'days').format("DD-MM-yyyy")}`,
      phrase: globalFilterValue == "" ? " " : globalFilterValue,
      price: priceSearchValue,
    };
    searchProject(pageNumber, totalRows, searchData).then((res) => {
      setApiLoading(true);
      if (res.status === 200) {
        if (res.data.length > 0) {
          setProjects(res.data);
          searchProjectCount(searchData).then((countRes) => {
            if (countRes.status === 200) {
              setTotalRecords(countRes.data);
              setApiLoading(false);
            } else setApiLoading(false);
          });
        } else {
          setApiLoading(false);
          setProjects([]);
        }
      } else {
        setProjects([]);
        setApiLoading(false);
      }
    });

  };

  return (
    <React.Fragment>
      <div>
        <Toast ref={toast} />
        <Spin spinning={apiLoading}>
          <div>
            <Toolbar
              className="mb-4"
              left={() => {
                return (
                  <React.Fragment>
                    <div>
                      <h3 className="m-0">Project Details</h3>
                    </div>
                  </React.Fragment>
                );
              }}
              right={() => {
                return (
                  <React.Fragment>
                    <span className="p-input-icon-left p-input-icon-right">
                      <i className="pi pi-search" />
                      <InputText
                        value={globalFilterValue}
                        onKeyUp={(e) => {
                          if(e.key === "Enter") {
                            console.log("KeyUp", e.key);
                            onGlobalFilterChange(startDate, endDate)
                          }
                        }}
                        onChange={(e) => {
                          const value = e.target.value;
                          setGlobalFilterValue(value);
                          setPriceSearchValue("");
                        }}
                        placeholder="Address Owner Search"
                      />

                      <i
                        className="pi pi-times"
                        style={{ cursor: "pointer" }}
                        onClick={() => {
                          setGlobalFilterValue("");
                          fetchProjectCount();
                        }}
                      />
                    </span>

                    {currentUser?.userType !== USER_TYPE_OWNER && <span className="p-input-icon-left p-input-icon-right" style={{ margin: "0rem 1rem" }}>
                      <i className="pi pi-search" />
                      <InputText
                        value={priceSearchValue}
                        type="number"
                        onKeyUp={(e) => {
                          if (e.key === "Enter") {
                            console.log("KeyUp", e.key);
                            onGlobalFilterChange(startDate, endDate)
                          }
                        }}
                        onChange={(e) => {
                          const value = e.target.value;
                          setGlobalFilterValue("");
                          setPriceSearchValue(value);
                        }}
                        placeholder="Price Search"
                      />

                      <i
                        className="pi pi-times"
                        style={{ cursor: "pointer" }}
                        onClick={() => {
                          setPriceSearchValue("");
                          fetchProjectCount();
                        }}
                      />
                    </span>}

                    <div style={{ margin: "0rem 1rem" }}>
                      <label style={{ marginRight: "0.5rem" }}>Start Date:</label>
                      <DatePicker
                        value={startDate}
                        onChange={(value) => {
                          setStartDate(value);
                          if ((value && endDate) || (value === null && endDate === null)) {
                            onGlobalFilterChange(value, endDate);
                          }
                        }}
                      />
                    </div>

                    <div style={{ margin: "0rem 1rem" }}>
                      <label style={{ marginRight: "0.5rem" }}>End Date:</label>
                      <DatePicker
                        value={endDate}
                        onChange={(value) => {
                          setEndDate(value);
                          if ((startDate && value) || (value === null && startDate === null) ) {
                            onGlobalFilterChange(startDate, value);
                          }
                        }}
                      />
                    </div>
                  </React.Fragment>
                );
              }}
            ></Toolbar>
          </div>
          <div>
            {projects?.map((row) => {
              // Determine if priorityCustomer should be true
              const showMessage =
                (currentUser?.userType !== "Customer" && row.projectMessage != null) ||
                (currentUser?.userType === "Customer" && row.customerMessage != null);
              return (
                <Tooltip
                  key={row?.projectId}
                  target={`.tooltip-row-${row?.projectId}`} // Unique class for each row
                  content={showMessage ? (currentUser?.userType !== "Customer" ? `${row?.projectMessage}` : `${row?.customerMessage}`) : ""} // Conditional Tooltip
                  position="top left"
                />
              );
            })}
            {/* {projectMissingE57Files?.length > 0 && currentUser?.userType !== "Customer" ? (
              <div style={{ flex: 1 }} className="notification-card">
                <span>Please check Project </span>
                {projectMissingE57Files.map((item) => (
                  <span><a href={`${window.location.origin}/${item[0]}/projectEdit`} target="_blank" rel="noreferrer" key={item[0]}>
                    {item[1]}
                  </a>, </span>))
                }
                <span> it’s not converting</span>
              </div>
            ) : ""} */}
            <DataTable
              rowHover // Enables row hover effect
              rowClassName={rowClassName}
              ref={dt}
              value={projects}
              dataKey="id"
              responsiveLayout="scroll"
              selectionMode="single"
              rowKey={projects}
              onRowClick={(e) => {
                window.localStorage.setItem(PROJECT_IDS, projects.map(t => t.id));
                history.push({
                  pathname: `${e.data.id}/projectEdit`,
                  state: {
                    id: e.data.id,
                  },
                });
              }}
            >
              <Column
                field="projectId"
                header={<span>ID</span>}
                body={(record) => (
                  <span style={{ whiteSpace: "nowrap" }}>
                    {record?.overdueProject ? (
                      <span style={{ color: "red", fontWeight: "bold" }}>! {record.projectId}</span>
                    ) : (
                      record.projectId
                    )}
                  </span>
                )}
              />
              <Column
                field="customer"
                header="Owner"
                body={(record) => {
                  return (
                    <React.Fragment>{record?.customer?.name}</React.Fragment>
                  );
                }}
              ></Column>
              <Column
                field="manager"
                header="Manager"
                body={(record) => {
                  return (
                    <React.Fragment>{record?.manager?.name}</React.Fragment>
                  );
                }}
              ></Column>
                <Column
                field="customer"
                header="Customer"
                body={(record) => {
                  return (
                    <React.Fragment>{record?.company?.name}</React.Fragment>
                  );
                }}
              ></Column>
              <Column
                field="employee"
                header="Contractor"
                body={(record) => {
                  return (
                    <React.Fragment>{record?.employee?.name}</React.Fragment>
                  );
                }}
              ></Column>
              <Column
                field="qualityChecker"
                header="Quality Checker"
                body={(record) => {
                  return (
                    <React.Fragment>
                      {record?.qualityChecker?.name}
                    </React.Fragment>
                  );
                }}
              ></Column>
              <Column
                header="Rework Type"
                body={(record) => {
                  if (record?.parentId != null)
                    return (
                      <React.Fragment>
                        Rework
                      </React.Fragment>
                    );
                  else if (record?.reworkProjects?.length > 0)
                    return <React.Fragment>
                      Original
                    </React.Fragment>
                  else
                    return <React.Fragment>
                    </React.Fragment>
                }}
              ></Column>
              <Column
                // field="importStatus"
                header="Import Status"
                body={(record) => {
                  if (
                    record?.import2d === 0 &&
                    record?.import3d === 0 &&
                    record?.importBackground === 0
                  )
                    return <React.Fragment></React.Fragment>;
                  else if (
                    record?.import2d === 1 ||
                    record?.import3d === 1 ||
                    record?.importBackground === 1
                  )
                    return (
                      <React.Fragment>
                        <img width={25}
                          src={inProgress}
                          alt="In Progress"
                        />
                      </React.Fragment>
                    );
                  else if (
                    record?.import2d === 2 &&
                    record?.import3d === 2 &&
                    record?.importBackground === 2
                  )
                    return (
                      <React.Fragment>
                        <img width={25}
                          src={ready}
                          alt="Ready"
                        />
                      </React.Fragment>
                    );
                }}
              ></Column>
              <Column align="center" field="product" header="Product"></Column>
              <Column
                align="left"
                // field="street"
                header="Project Address"
                body={(record) => {
                  return (
                    <React.Fragment>
                      {record &&
                      (record.street != null ||
                        record.number != null ||
                        record.city != null)
                        ? record.street +
                          " " +
                          record.number +
                          " " +
                          record.city
                        : ""}
                    </React.Fragment>
                  );
                }}
              ></Column>

              <Column
                align="center"
                field="houseType"
                header="House Type"
              ></Column>
              <Column
                field="ndd"
                header="NDD"
                body={(record) => {
                  return record?.ndd === "Yes" ? (
                    <React.Fragment>
                      <div style={{ border: "2px solid red" }}>
                        <b>{record?.ndd}</b>
                      </div>
                    </React.Fragment>
                  ) : (
                    <React.Fragment>{record?.ndd}</React.Fragment>
                  );
                }}
              />
              <Column
                field="autocad"
                header="Is AutoCad"
                body={(record) => {
                  return isAutoCad(record) ? (
                    <React.Fragment>
                        <div style={{ border: "2px solid red", width:"27px" }}>
                        <b>Yes</b>
                      </div>
                    </React.Fragment>
                  ) : (
                    <React.Fragment>No</React.Fragment>
                  );
                }}
              />
              <Column
                field="agency"
                header="Agency"
                body={(record) => {
                  return (
                    <React.Fragment>
                      {record?.agency?.name + " " + record?.agency?.postCode}
                    </React.Fragment>
                  );
                }}
              ></Column>
              <Column
                align="center"
                field="projectStatus"
                header="Status"
                body={(record) => {
                  return getProjectStatus(record);
                }}
              ></Column>
              <Column
                align="center"
                field="eta"
                header="ETA"
                body={(record) => {
                  return compareEta(
                    record,
                    etaDateDisplay(currentUser, record)
                  );
                }}
              ></Column>
              <Column
                align="center"
                field="creationDate"
                header="Creation Date"
              ></Column>
              <Column
                align="center"
                field="measurementDate"
                header="Measurement Date"
              ></Column>
              <Column
                field="action"
                header="Action"
                body={(record) => {
                  return (
                    <React.Fragment>
                      <div className="flex justify-content-center">
                        <div>
                          <Popover
                            placement="leftBottom"
                            content={() => content(record)}
                          >
                            <Button
                              type="button"
                              icon="pi pi-ellipsis-v"
                              aria-haspopup
                              aria-controls="overlay_panel"
                              className="select-product-button"
                              style={{ backgroundColor: "#037eea" }}
                            />
                          </Popover>
                        </div>
                      </div>
                    </React.Fragment>
                  );
                }}
              ></Column>
            </DataTable>
            <Paginator
              first={basicFirst}
              rows={totalRows}
              totalRecords={totalRecords}
              rowsPerPageOptions={[30, 60, 90]}
              onPageChange={onBasicPageChange}
            ></Paginator>
          </div>
        </Spin>
        <AssignToContractorDialog
          visible={visibleContractorDialog}
          setVisible={changeVisibleContractorDialogState}
          project={project}
        />

        <AssigntoqualityCheckerDialog
          visible={visibleQualityCheckerDialog}
          setVisible={changeVisibleQualityCheckerDialogState}
          project={project}
        />

        <AssignToManagerDialog
          visible={visibleManagerDialog}
          setVisible={changeVisibleManagerDialogState}
          project={project}
        />

        <CustomerRequestChangeDialog
          visible={visibleCustomerRequestChangeDialog}
          setVisible={changeVisibleCustomerRequestChangeDialogState}
          project={project}
        />
        <FeedbackDialog
        visible={visibleFeedbackDialog}
        setVisible={changeVisibleFeedbackDialogState}
        project={project}
        currentUser={currentUser}
      />
      </div>
    </React.Fragment>
  );
};
export default ProjectDetail;
